/* eslint-disable no-nested-ternary, @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import type { PropsWithChildren } from 'react';
import React from 'react';

export const getComponentFromProps = (
  Component: React.ReactElement<PropsWithChildren<unknown>> | React.ComponentType<unknown>,
  props: Record<string, unknown>,
  children = [],
) => {
  if (!Component) return null;
  const componentChildren =
    typeof Component !== 'function' && Component.props
      ? Array.isArray(Component.props.children)
        ? Component.props.children
        : [Component.props.children]
      : null;
  return typeof Component === 'function' ? (
    <Component {...props}>{children}</Component>
  ) : (
    React.cloneElement(
      Component,
      {
        ...Component.props,
        ...props,
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      componentChildren ? [...componentChildren, ...children] : [...children],
    )
  );
};

export default getComponentFromProps;
